import CustomTag from 'components/CustomTag'
import React from 'react'

const DriveStatus = ({ status = 'PENDING' }) => {
  let colorType
  let tagMessage
  if (status == 'REQUESTED') {
    colorType = 'grey'
    tagMessage = 'Requested'
  } else if (status == 'CANCELLED') {
    colorType = 'red'
    tagMessage = 'Cancelled'
  } else if (status == '-1') {
    colorType = 'red'
    tagMessage = 'Blacklisted'
  } else if (status == '0') {
    colorType = 'grey'
    tagMessage = 'Invite Sent'
  } else if (status == 'PENDING') {
    colorType = 'orange'
    tagMessage = 'Pending'
  } else if (status == 'CONFIRMED') {
    colorType = 'green'
    tagMessage = 'Confirmed'
  } else if (status == 'RESCHEDULE_REQUESTED') {
    colorType = 'grey'
    tagMessage = 'Reschedule'
  }
  return (
    <CustomTag colorType={colorType} message={tagMessage} bordered={false} />
  )
}

export default DriveStatus
